<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Dados Gerais' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>
  <ion-card>
    <div class="teste-padd">
      <ion-grid>
        <ion-row>
          <ion-col class="img-wrapper">
            <img [src]="pessoa.foto | image:' '" />

            <ion-button
              *ngIf="!membro && userProvider.hasConfig(4) && mostrarCamera && editar"
              (click)="alterarFoto(pessoa)"
              class="box-icon"
            >
              <i class="fa-solid fa-camera camera-edit"></i>
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>

      <div class="top-img">
        <ion-item lines="none">
          <ion-label class="title-per">
            {{'Dados do perfil' | translate}}
          </ion-label>
        </ion-item>

        <ion-item>
          <ion-label>
            <p class="title-info">{{'Nome' | translate}}</p>
            <p class="dados-info">{{pessoa.nome}}</p>
          </ion-label>
        </ion-item>

        <ion-item *ngIf="!membro">
          <ion-label>
            <p class="title-info">{{'Nascimento' | translate}}</p>
            <p class="dados-info">
              {{pessoa.nascimento | dateFormat : "ddmmyyyy"}}
               <span *ngIf="pessoa.nascimento" class="idade"> {{getIdade(pessoa.nascimento)}} {{('Anos' | translate)}}</span>
            </p>
          </ion-label>
          <i class="fa-thin fa-calendar" slot="end"></i>
        </ion-item>

        <ion-item *ngIf="!membro || userProvider.hasConfig(103)">
          <ion-label>
            <p class="title-info">{{'Sexo' | translate }}</p>
            <p class="dados-info">
              {{pessoa.sexo ? pessoa.sexo : ('Não Informado' | translate)}}
            </p>
          </ion-label>
        </ion-item>

        <ion-item>
          <ion-label>
            <p class="title-info">{{'Estado Civil' | translate}}</p>
            <p class="dados-info" text-capitalize>
              {{pessoa.estadoCivil ? pessoa.estadoCivil : ('Não Informado' |
              translate)}}
            </p>
          </ion-label>
        </ion-item>

        <div *ngIf="meuCadastro || permissaoVisitante || permissao">
          <ion-item lines="none">
            <ion-label>
              <div class="endereco-header">
                <p class="title-info">{{'Endereço' | translate}}</p>
                <i class="fas fa-pen edit" (click)="editarEndereco(pessoa);"
                *ngIf="(!meuCadastro && editar && pessoa.podeEditar) || (meuCadastro && userProvider.hasConfig(4))"></i>
              </div>
              
              <p class="dados-info" text-capitalize>
                {{pessoa.endereco | endereco}}
              </p>
            </ion-label>
          </ion-item>
        </div>

        <ion-item lines="none" *ngIf="!membro || userProvider.hasConfig(103)">
          <ion-label class="title-per">{{'Contato' | translate}}</ion-label>
        </ion-item>

        <ion-item *ngIf="!membro || userProvider.hasConfig(103)">
          <ion-label>
            <p class="title-info">{{'Email' | translate}}</p>
            <a class="dados-info" href="mailto:{{pessoa.contato.email}}">
              {{pessoa.contato.email ? pessoa.contato.email : ('Não Informado' |
              translate)}}
            </a>
          </ion-label>
        </ion-item>

        <ion-item *ngIf="pessoa.contato && pessoa.contato.telCelular && (!membro || userProvider.hasConfig(103))">
          <ion-label>
            <p class="title-info">{{'Celular' | translate}}</p>
            <a class="dados-info" href="tel:{{pessoa.contato.telCelular}}">
              {{pessoa.contato.telCelular ? (pessoa.contato.telCelular |  phone:pessoa.contato.ddiTelCelular) : ('Não Informado' | translate)}}
            </a>
          </ion-label>
          <a
            [href]="'https://api.whatsapp.com/send?phone=' + ddi.replace('+', '') + pessoa.contato.telCelular"
            slot="end"
          ><i class="fa-brands fa-whatsapp logo-whatsapp"></i></a>
        </ion-item>

        <ion-item *ngIf="!membro || userProvider.hasConfig(103) || permissao">
          <ion-label>
            <p class="title-info">{{'Telefone' | translate}}</p>
            <a class="dados-info" href="tel:{{pessoa.contato.telResidencial }}">
              {{pessoa.contato.telResidencial | phone:pessoa.contato.ddiTelResidencial}}
            </a>
          </ion-label>
        </ion-item>
      </div>
    </div>
  </ion-card>

  <ion-button
    expand="block"
    class="button-editar"
    (click)="editarDados(pessoa);"
    *ngIf="!membro && (!meuCadastro && pessoa.podeEditar && editar) || (meuCadastro && userProvider.hasConfig(4)) || (!meuCadastro && autorizadoEditar)"
    >{{'Editar' | translate}} <i class="fas fa-pen edit"></i
  ></ion-button>
</ion-content>
